import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-super-admin',
    templateUrl: './super-admin.component.html',
    styleUrls: ['./super-admin.component.scss']
})

export class SuperAdminComponent implements OnInit {

    constructor(public userService: UserService,
                public router: Router) { }

    ngOnInit(): void {}

}
